import { StringParam, useQueryParams } from 'use-query-params'

export const useCandidateDetailsQueryParams = () =>
  useQueryParams({
    tasksView: StringParam,
    comments: StringParam,
    formId: StringParam
  })
